import { render, staticRenderFns } from "./ViewOrderCreationSubmission.vue?vue&type=template&id=f9e6bc90&scoped=true&"
import script from "./ViewOrderCreationSubmission.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderCreationSubmission.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOrderCreationSubmission.vue?vue&type=style&index=0&id=f9e6bc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e6bc90",
  null
  
)

export default component.exports